import AddPizzaController from 'add-pizza.controller';

export default {
	templateUrl: 'src/pizza/components/add-pizza/add-pizza.template.html',
	controller: AddPizzaController
};